<ng-container *ngIf="(service.user | async) == null; else signedIn">
  <app-signin></app-signin>
</ng-container>

<ng-template #signedIn>

  <mat-horizontal-stepper [linear]="true" *ngIf="buchung">

    <mat-step [stepControl]="stammdatenFormGroup">
      <form [formGroup]="stammdatenFormGroup">
        <ng-template matStepLabel>Stammdaten</ng-template>
        <p>Bitte Daten des Buchenden eingeben oder kontrollieren:</p>
        <div class="alert alert-info">
          Diese Person ist für die Buchung und Zahlung verantwortlich.
          <br>Weitere oder andere Teilnehmer können im nächsten Schritt hinzugefügt werden.
        </div>
        <app-stammdaten formControlName="stammdaten" [user]="user"></app-stammdaten>
        <br>
        <mat-divider></mat-divider>
        <!--<br><app-corona-hinweis></app-corona-hinweis>-->
        <button mat-button color="primary" matStepperNext>Weiter</button>
      </form>
    </mat-step>

    <mat-step [stepControl]="weitereTeilnehmerFormGroup">
      <form [formGroup]="weitereTeilnehmerFormGroup">
        <ng-template matStepLabel>Teilnehmer</ng-template>
        <p>Optional können weitere Teilnehmer hinzugefügt werden.</p>
        <div class="alert alert-info">
          Diese Möglichkeit ist z.B. für Familien gedacht wenn eine Person für mehrere Teilnehmer bucht und bezahlt.
          <br>Weitere Teilnehmer können nicht selbst bezahlen.
        </div>
        <app-teilnehmer formControlName="teilnehmer" [buchung]="buchung"></app-teilnehmer>
        <br>
        <mat-divider></mat-divider>
        <button mat-button color="primary" matStepperPrevious>Zurück</button>
        <button mat-button color="primary" matStepperNext>Weiter</button>
      </form>
    </mat-step>

    <mat-step [stepControl]="reisenFormGroup">
      <form [formGroup]="reisenFormGroup">
        <ng-template matStepLabel>Reisen wählen</ng-template>
        <p>Bitte eine oder mehrere Reisen auswählen:</p>
        <table class="table">
          <tr>
            <th>Buchen</th>
            <th>Datum</th>
            <th>Reise</th>
          </tr>
          <tr *ngFor="let reise of reisen | async">
            <td>
              <mat-checkbox (change)="reiseSelected(reise, $event.checked)" color="primary"></mat-checkbox>
            </td>
            <td>{{reise.dateString}}</td>
            <td>{{reise.name}}</td>
          </tr>
        </table>
        <mat-divider></mat-divider>
        <div [hidden]="reisenFormGroup.valid || !reisenFormGroup.touched" class="alert alert-warning">
          Bitte mindestens eine Reise auswählen!
        </div>
        <button mat-button color="primary" matStepperPrevious>Zurück</button>
        <button mat-button color="primary" matStepperNext (click)="reisenFormGroup.markAsTouched()">Weiter</button>
      </form>
    </mat-step>

    <mat-step [stepControl]="optionenFormGroup">
      <form [formGroup]="optionenFormGroup">
        <ng-template matStepLabel>Optionen wählen</ng-template>
        <p>Bitte Optionen auswählen:</p>
        <app-buchung-optionen formControlName="optionen" #optionen [buchung]="buchung"></app-buchung-optionen>
        <mat-divider></mat-divider>
        <div [hidden]="optionenFormGroup.valid || !optionenFormGroup.touched" class="alert alert-warning">
          Bitte mindestens eine Buchung auswählen und alle erforderlichen Felder (*) ausfüllen!
        </div>
        <button mat-button color="primary" matStepperPrevious (click)="optionenFormGroup.markAsTouched()">Zurück</button>
        <button mat-button color="primary" matStepperNext>Weiter</button>
      </form>
    </mat-step>

    <mat-step [stepControl]="rechnungFormGroup">
      <form [formGroup]="rechnungFormGroup">
        <ng-template matStepLabel>Absenden</ng-template>
        <p>Bitte überprüfe die Anfrage noch einmal. Nach dem Absenden wird geprüft, ob die gewünschten Plätze frei sind.</p>
        <app-rechnung [buchung]="buchung"></app-rechnung>
        <div class="alert alert-info">{{service.texte.hinweisZahlung()}}</div>
        <mat-checkbox formControlName="agb" color="primary" required>
          Ich stimme folgendem zu:
        </mat-checkbox><br>
        <div [innerHTML]="texte.hinweisBorderReiseMitPartyCharakter()"></div>
        <div [innerHTML]="texte.hinweisVermittlung()"></div>
        <!--<div [innerHTML]="texte.hinweisCoronaRegelungen()"></div>-->
        <br>
        <mat-divider></mat-divider>
        <button mat-button color="primary" matStepperPrevious>Zurück</button>
        <button mat-button color="primary" matStepperNext (click)="sendAnfrage()"
                [disabled]="!rechnungFormGroup.valid">Anfrage absenden</button>
      </form>
    </mat-step>
  </mat-horizontal-stepper>

</ng-template>
